import webcall from '@/libs/webcall';

const getQueries = url => url
  .split('&')
  .map(queryString => queryString.split('='))
  .map(([key, value]) => [key, decodeURIComponent(value)])
  .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export default {
  validate() {
    const queries = getQueries(location.search.substring(1));
    if (!queries.key) return Promise.reject(new Error('key is not specified'));

    return webcall.liftoffs.validate(queries.key)
      .then(({ data }) => data);
  },
};



// WEBPACK FOOTER //
// ./src/libs/LinkValidator.js